import { render } from "./RInput.vue?vue&type=template&id=1ef8d234"
import script from "./RInput.vue?vue&type=script&lang=js"
export * from "./RInput.vue?vue&type=script&lang=js"

import "./RInput.vue?vue&type=style&index=0&id=1ef8d234&lang=css"
script.render = render

export default script